import { useFormContext, useFormField } from '@calendly/form'
import { useCallback } from 'react'

import RawColorField from 'components/external/color_picker'

export const ColorField = ({ label, valueType, ...props }) => {
  const { setFieldValue, setFieldTouched } = useFormContext()
  const [{ name, ...fieldProps }] = useFormField(props)

  const onChange = useCallback((value) => {
    setFieldValue(name, valueType ? value[valueType] : value)
    setFieldTouched(name, true)
  }, [name, setFieldTouched, setFieldValue, valueType])


  return (
    <RawColorField
      label={label}
      name={name}
      {...fieldProps}
      onChange={onChange}
    />
  )
}
